import { render, staticRenderFns } from "./BulkProductGridItem.vue?vue&type=template&id=371d9706&scoped=true&"
import script from "./BulkProductGridItem.vue?vue&type=script&lang=js&"
export * from "./BulkProductGridItem.vue?vue&type=script&lang=js&"
import style0 from "./BulkProductGridItem.vue?vue&type=style&index=0&id=371d9706&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371d9706",
  null
  
)

export default component.exports